import { getServicePlacements as getServicePlacementsGetter } from '@/store/modules/placements/getters';
import { getVersionsOfPlacement as getVersionsOfPlacementGetter } from '@/store/modules/placements/modules/versions/getters';
import { useStore } from '@/utils/store';
import { Placement, PlacementId, PlacementVersion, ServiceId } from '@ply-io/ply-front-shared-utilities';

export const usePlacementsGetters = () => {
	const { getter } = useStore();
	return {
		getServicePlacements: getter<(serviceId: ServiceId) => Placement[]>(getServicePlacementsGetter),
		getVersionsOfPlacement: getter<(placementId: PlacementId) => PlacementVersion[]>(getVersionsOfPlacementGetter),
	};
};
